import React from "react"
import { FormattedMessage } from "react-intl"
import { connect } from "react-redux"
import {
  clearPropertyFilters,
  closeGeneralModal,
} from "../../actions/settingsActions"
import ChevLeft from "../../assets/icons/chevLeft"
import ClearFilter from "../../assets/icons/clearFilter"
import AdvancedFilters from "./AdvancedFilters"
import Button from "../button"

const AdvancedFiltersModal = ({
  clearPropertyFilters,
  closeGeneralModal,
  onApplyFilters,
}) => {
  const handleClickApply = () => {
    onApplyFilters()
    closeGeneralModal()
  }
  return (
    <div className="whiteBg shadow py-5 advanced-filter__sidebar">
      <aside className="px-4 __content">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <button onClick={closeGeneralModal} className="me-2">
              <ChevLeft style={{ width: "7px" }} />
            </button>
            <h4 className="px20 black font-bold mb-0">
              <FormattedMessage defaultMessage="Advanced Filter" />
            </h4>
          </div>
          <div className="d-flex space-x-8">
            <Button color="secondary" onClick={handleClickApply}>
              <FormattedMessage defaultMessage="Apply Filters" />
            </Button>
            <Button onClick={clearPropertyFilters}>
              <FormattedMessage defaultMessage="Clear Filter" />
            </Button>
          </div>
        </div>
        <AdvancedFilters />
      </aside>
    </div>
  )
}

export default connect(null, { clearPropertyFilters, closeGeneralModal })(
  AdvancedFiltersModal
)
